"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
Object.defineProperty(exports, "__esModule", { value: true });
exports.HzF32T = exports.HzF32 = void 0;
/**
 * Frequency as 32 bit float
 */
class HzF32 {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    f() {
        return this.bb.readFloat32(this.bb_pos);
    }
    static sizeOf() {
        return 4;
    }
    static createHzF32(builder, f) {
        builder.prep(4, 4);
        builder.writeFloat32(f);
        return builder.offset();
    }
    unpack() {
        return new HzF32T(this.f());
    }
    unpackTo(_o) {
        _o.f = this.f();
    }
}
exports.HzF32 = HzF32;
class HzF32T {
    constructor(f = 0.0) {
        this.f = f;
    }
    pack(builder) {
        return HzF32.createHzF32(builder, this.f);
    }
}
exports.HzF32T = HzF32T;
